// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"8e3fe283","912":"3e07dc13"}[chunkId] + ".chunk.js";
};